module.exports = flarum.core.compat['utils/humanTime'];